import {differenceInYears} from "date-fns";

const calculateYearsDifference = (initialDate) => {
    let year =  Number(initialDate.substr(6, 4));
    let month = Number(initialDate.substr(3, 2));
    let day =   Number(initialDate.substr(0, 2))

    return differenceInYears(
        new Date(),
        new Date(
            year,
            month > 1 ? month - 1 : month,
            day
        )
    );
}

export default calculateYearsDifference;
